module.exports = __webpack_public_path__ + "fonts/Lato-Light.72443183.woff2";